import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCostImportsApi } from "../../http/costImports/api";
import { CostImport } from "../../http/costImports/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteCostImportDialogProps = {
  cotsImport: CostImport;
  onClose: () => void;
};

const DeleteCostImportDialog: FC<DeleteCostImportDialogProps> = ({ cotsImport, onClose }) => {
  const i18n = useI18n();
  const costImportsApi = useCostImportsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={() => onClose}
      title={i18n.t.costsImport.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: () => onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            costImportsApi
              .deleteAdminCostImport(cotsImport)
              .then(() => {
                dispatch(showSuccessNotification(i18n.t));
                onClose();
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.costsImport.questions.deleteImport}
    </ModalDialog>
  );
};

export default DeleteCostImportDialog;
